import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, id }) => (
  <Reveal className="mb-14">
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D9A441] mb-4" data-testid={`${id}-overline`}>
      {overline}
    </p>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-none text-[#F3EFE6]">
      {title}
    </h2>
  </Reveal>
);
